function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n    .st0{opacity:0.15;fill:#1EA3CE;}\n    .st1{fill:#7D5544;}\n    .st2{fill:#F1C29A;}\n    .st3{fill:#663521;}\n    .st4{fill:#FFFFFF;}\n    .st5{opacity:0.1;fill:#1B1D21;}\n    .st6{fill:#1BA3CE;}\n    .st7{fill:#F8BBBC;}\n    .st8{fill:#ECA3AD;}\n    .st9{fill:#231F20;}\n    .st10{fill:#5C6169;}\n    .st11{fill:#D4D2CF;}\n    .st12{fill:#F7C8BF;}\n    .st13{fill:#414042;}\n    .st14{fill:#1C4270;}\n    .st15{opacity:5.000000e-02;fill:#1B1D21;}\n    .st16{fill:#1EA3CE;}\n    .st17{fill:#FF9E00;}\n    .st18{fill:none;}\n    .st19{fill:#ECAE8D;}\n    .st20{fill:#7F572A;}\n    .st21{fill:#A17940;}\n    .st22{opacity:0.15;fill:#1BA3CE;}\n    .st23{fill:#D5D2D0;}\n    .st24{fill:#F9BCBD;}\n    .st25{fill:#EDA4AE;}\n    .st26{fill:#675B5B;}\n    .st27{fill:#E6E6E6;}\n    .st28{fill:#501616;}\n    .st29{fill:#333B44;}\n    .st30{opacity:0.99;fill:#E6E6E6;enable-background:new    ;}\n    .st31{fill:#A02C2C;}\n    .st32{fill:#784421;}\n    .st33{fill:#A05A2C;}\n    .st34{fill:#00BA6B;}\n    .st35{fill:#E6A800;}\n    .st36{fill:#88949F;}\n    .st37{opacity:0.45;fill:#00BA6B;}\n    .st38{fill:#7F3DB3;}\n    .st39{fill:#5B3A2F;}\n    .st40{fill:#B58361;}\n    .st41{fill:#FF9F00;}\n    .st42{fill:#1DA3CE;}\n    .st43{fill:#1AA3CE;}\n    .st44{opacity:0.3;fill:#1AA3CE;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_12"
}, React.createElement("path", {
  className: "st0",
  d: "M297.1,145.9c29.9-7.7,47.8-38.1,40.2-67.9c-7.6-29.9-38.1-47.9-67.9-40.2C268.1,38.1,137.9,71,10.6,71         C6.9,71,3.4,71,0,70.9v111.6c3.5,0,7,0.1,10.6,0.1C152.3,182.6,291.3,147.4,297.1,145.9z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_6"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_9"
}, React.createElement("g", null, React.createElement("path", {
  className: "st38",
  d: "M248.8,89.8c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.5-1-0.1-1.4c0.3-0.3,0.5-0.7,0.8-1c0.3-0.4,1-0.5,1.4-0.2             c0.4,0.3,0.5,1,0.2,1.4c-0.3,0.3-0.5,0.7-0.8,1C249.4,89.7,249.1,89.8,248.8,89.8z"
}), React.createElement("path", {
  className: "st38",
  d: "M105.1,161.9c-0.5,0-0.9-0.3-1-0.8c-0.1-0.5,0.2-1.1,0.8-1.2c59.9-13,70.5-38.1,72.3-45.5             c0.2-0.7,0.3-1.4,0.4-2c-2.8-1.4-4.8-3.2-5.5-5.2c-0.7-1.7-0.4-3.4,0.9-4.8c0.1-0.1,0.2-0.2,0.4-0.3c1.4-0.6,2.8-0.4,4,0.6             c1.9,1.6,2.7,4.7,2.4,8.5c2.6,1.1,5.9,2.1,10,2.6c0.5,0.1,0.9,0.6,0.9,1.1c-0.1,0.5-0.6,0.9-1.1,0.9c-3.8-0.5-7.2-1.3-10.1-2.5             c-0.1,0.5-0.2,1.1-0.3,1.7c-1.9,7.7-12.8,33.7-73.8,47C105.2,161.9,105.1,161.9,105.1,161.9z M174.3,103.9             c-0.6,0.8-0.8,1.7-0.4,2.6c0.5,1.2,1.8,2.5,3.9,3.7c0.1-3-0.7-5.1-1.8-6C175.4,103.8,174.9,103.7,174.3,103.9z"
}), React.createElement("path", {
  className: "st38",
  d: "M95.4,163.8c-0.5,0-0.9-0.3-1-0.8c-0.1-0.5,0.3-1.1,0.8-1.2c1.3-0.2,2.6-0.5,3.9-0.7             c0.5-0.1,1.1,0.2,1.2,0.8c0.1,0.5-0.2,1.1-0.8,1.2c-1.3,0.2-2.6,0.5-3.9,0.7C95.5,163.8,95.4,163.8,95.4,163.8z"
}), React.createElement("path", {
  className: "st38",
  d: "M87.1,165.3c-0.5,0-0.9-0.4-1-0.8c-0.1-0.5,0.3-1.1,0.8-1.1c0.9-0.1,1.8-0.3,2.8-0.4             c0.5-0.1,1.1,0.3,1.1,0.8c0.1,0.5-0.3,1.1-0.8,1.1c-0.9,0.1-1.8,0.3-2.8,0.4C87.2,165.2,87.1,165.3,87.1,165.3z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st18",
  d: "M224.2,118.4l-1.7-1.9l-1,8.1l3.5,0.6l9.4,5.9l2-19.8l-8,7.3C227.2,119.7,225.3,119.6,224.2,118.4z"
}), React.createElement("path", {
  className: "st39",
  d: "M217.2,92.1c2.1,0.4,3.7,1.2,4.8,2.6c3.3-0.3,6.4-1,8.7-2.1c12.6-5.5,8.3-27.3,2.6-34             c-5.7-6.7-10-7.6-15.3-8.1c-16.6-1.6-23.4,17.8-22.3,34.3c0.3,5.2,6.4,8.2,13.6,9.5C212,92,215.1,91.7,217.2,92.1z"
}), React.createElement("polygon", {
  className: "st38",
  points: "204.9,103.2 204.9,103.2 204.9,103.2       "
}), React.createElement("path", {
  className: "st38",
  d: "M210,95.7c2.3-1.5,5.6-0.4,7.5,2.4l3.8,5.8l2.5,0.3c0.5-4.3-0.2-7.4-1.8-9.4c-1.2-1.4-2.8-2.3-4.8-2.6             c-2.1-0.4-5.2,0-7.8,2.3c-1.8,1.5-3.3,4-4.2,7.6l0,0l-0.2,1.3l0,0l-3.2,17.7l0,0l0,0l19.8,3.6l1-8.1l-7.4-8.4l-1.9,1.2l-3.9-5.8             c-0.2-0.4-0.5-0.8-0.6-1.1C207.6,99.8,208.1,97,210,95.7z"
}), React.createElement("polygon", {
  className: "st38",
  points: "221.4,103.9 220.4,104.5 223.5,108 224,104.1 223.9,104.1 221.4,103.8       "
}), React.createElement("path", {
  className: "st6",
  d: "M203.4,134l3.5,14.6l-12.1,17.8c5.1-0.8,10-1.7,14.8-2.5l10.2-15.3l-1.1-8.7l-6.4-0.9             C208.6,138.7,205.4,136.8,203.4,134z"
}), React.createElement("path", {
  className: "st5",
  d: "M203.4,134l3.5,14.6l-12.1,17.8c5.1-0.8,10-1.7,14.8-2.5l10.2-15.3l-1.1-8.7l-6.4-0.9             C208.6,138.7,205.4,136.8,203.4,134z"
}), React.createElement("path", {
  className: "st6",
  d: "M225,125.2l-3.5-0.6l-19.8-3.6l0,0l-0.6,2.8c-0.8,3.8,0.1,7.5,2.3,10.3c2.1,2.8,5.3,4.7,9,5l6.4,0.9l10.1,1.5             l3.5,9.8l2-20.1L225,125.2z"
}), React.createElement("path", {
  className: "st6",
  d: "M246,157.2l-8.8-24.3l-1-0.6l-2.4,23.4l1.3,3.7C238.9,158.6,242.6,157.9,246,157.2z"
}), React.createElement("path", {
  className: "st29",
  d: "M239.3,102.3l1.1-11.3c0.1-0.5-0.3-1-0.9-1.1c-0.6-0.1-1,0.3-1.1,0.9l-1.1,11.1             C238.1,101.9,238.7,102,239.3,102.3z"
}), React.createElement("path", {
  className: "st29",
  d: "M238.5,110.4c-0.4,0.1-0.8,0.1-1.2,0.1l-0.9,0.8l-2,19.8l-2,20.1l-0.9,8.8c0.7-0.1,1.4-0.3,2.1-0.4l0.4-4             l2.4-23.4L238.5,110.4z"
}), React.createElement("path", {
  className: "st38",
  d: "M221.4,103.9L221.4,103.9l-3.9-5.8c-1.9-2.8-5.2-3.9-7.5-2.4c-2,1.3-2.4,4.1-1.3,6.7             c0.2,0.4,0.4,0.8,0.6,1.1l3.9,5.8l1.9-1.2l5.3-3.5L221.4,103.9z"
}), React.createElement("path", {
  className: "st40",
  d: "M241.4,104.5c-0.4-1-1.2-1.7-2.1-2.2c-0.6-0.3-1.3-0.5-2-0.4c-0.5,0-1.1,0.1-1.6,0.4             c-1.5,0.7-2.5,2.1-2.6,3.7l-6.7,5.4l-2.9-3.3l-3.1-3.5l-5.3,3.5l7.4,8.4l1.7,1.9c1.1,1.3,3,1.4,4.3,0.2l8-7.3l0.9-0.8             c0.4,0,0.8,0,1.2-0.1c0.2-0.1,0.4-0.1,0.7-0.2C241.4,109.2,242.4,106.7,241.4,104.5z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st40",
  d: "M235,73.5c-0.4-0.2-0.9-0.1-1.2,0.2c-0.2-9.6-6.8-17.3-15.8-17.3c-8.9,0-15.1,7.6-15.3,17.2             c-0.5-0.2-1.1-0.2-1.7,0c-1.8,0.7-2.8,2.9-1.7,5.8c0.7,1.9,3.1,3.3,5,3c2,4.6,5.6,7.9,10.2,9c0,0.2,0,0.3,0,0.5             c0,1.2,1.2,2.1,2.7,2.1c1.5,0,2.7-0.9,2.7-2.1c0-0.1,0-0.2,0-0.2c5.7-0.7,10.2-4.6,12.4-9.9c1.5-0.2,3.6-1.8,4.2-3.5             C237.3,75.6,236.2,74,235,73.5z"
}), React.createElement("ellipse", {
  className: "st3",
  cx: 212.9,
  cy: 76.8,
  rx: 1.7,
  ry: 2.4
}), React.createElement("ellipse", {
  className: "st3",
  cx: 225.9,
  cy: 76.8,
  rx: 1.7,
  ry: 2.4
}), React.createElement("g", null, React.createElement("path", {
  className: "st4",
  d: "M219.4,87.8c-2.8,0-5.1-2.1-5.4-4.8c0-0.4,0.2-0.7,0.6-0.7h9.7c0.4,0,0.6,0.3,0.6,0.7                 C224.5,85.7,222.2,87.8,219.4,87.8z"
})), React.createElement("path", {
  className: "st39",
  d: "M221.7,60.9c0,0-6.7,12.4-15.6,13.3c-8.9,0.9-7.4-15.2,4.1-19.7c11.5-4.5,25.8,0,25,14.5             S221.7,60.9,221.7,60.9z"
}), React.createElement("path", {
  className: "st38",
  d: "M198.4,65.9c-1.7-8.7,4.8-17.3,14.4-19.2c9.7-1.9,18.9,3.6,20.6,12.3c0,0-5.6-0.7-17.9,1.7             C204.9,62.9,198.4,65.9,198.4,65.9z"
}), React.createElement("path", {
  className: "st38",
  d: "M211.6,61c-1.2,0-2.3-0.9-2.4-2.1c-0.2-1.3,0.8-2.6,2.1-2.8c0.8-0.1,19.6-2.6,28.4-1.4             c1.3,0.2,2.3,1.4,2.1,2.8c-0.2,1.3-1.4,2.3-2.8,2.1c-8.2-1.1-26.9,1.4-27.1,1.4C211.8,61,211.7,61,211.6,61z"
})), React.createElement("g", null, React.createElement("rect", {
  x: 310.4,
  y: 118.4,
  className: "st36",
  width: 29.2,
  height: 36.3
}), React.createElement("path", {
  className: "st41",
  d: "M312.8,85.1l-2.3-0.8c-2.6-0.9-4.9-2.5-6.7-4.7c-2-2.5-3.1-5.7-3.1-9v-2.5c0-0.9,0.7-1.6,1.6-1.6h8.3             l-3.7-3.2h-4.6c-2.7,0-4.8,2.2-4.8,4.8v2.5c0,4,1.4,7.9,3.9,11c2.1,2.7,4.9,4.6,8.2,5.7l2.3,0.8c0.2,0.1,0.3,0.1,0.5,0.1             c0.7,0,1.3-0.4,1.5-1.1C314.1,86.3,313.6,85.4,312.8,85.1z"
}), React.createElement("path", {
  className: "st17",
  d: "M329.9,94.9v2.4c0,0.9,0.7,1.6,1.6,1.6c2.7,0,4.8,2.2,4.8,4.8v3.2c0,0.9-0.7,1.6-1.6,1.6h-19.5             c-0.9,0-1.6-0.7-1.6-1.6v-3.2c0-2.7,2.2-4.8,4.8-4.8c0.9,0,1.6-0.7,1.6-1.6v-2.4c-6-1.9-10.4-7.2-11.1-13.5l-2-18h36l-2,18             C340.3,87.7,335.9,93,329.9,94.9z"
}), React.createElement("path", {
  className: "st41",
  d: "M336.1,87.1c0.2,0.7,0.9,1.1,1.5,1.1c0.2,0,0.3,0,0.5-0.1l2.3-0.8c3.2-1.1,6-3,8.2-5.7c2.5-3.1,3.9-7,3.9-11             v-2.5c0-2.7-2.2-4.8-4.8-4.8H343l-3.7,3.2h8.3c0.9,0,1.6,0.7,1.6,1.6v2.5c0,3.2-1.1,6.4-3.1,9c-1.7,2.2-4,3.8-6.7,4.7l-2.3,0.8             C336.3,85.4,335.9,86.3,336.1,87.1z"
}), React.createElement("path", {
  className: "st17",
  d: "M333,75.6c-0.2-0.6-0.7-1-1.3-1.1l-3.6-0.5l-1.6-3.2c-0.3-0.5-0.9-0.8-1.4-0.8s-1.2,0.3-1.4,0.8l-1.6,3.2             l-3.6,0.5c-0.6,0.1-1.1,0.5-1.3,1.1c-0.2,0.6,0,1.2,0.5,1.6l2.6,2.5l-0.6,3.5c-0.1,0.6,0.1,1.2,0.6,1.6c0.5,0.4,1.2,0.4,1.7,0.1             l3.3-1.7l3.3,1.7c0.5,0.3,1.2,0.2,1.7-0.1c0.5-0.4,0.7-1,0.6-1.6l-0.6-3.5l2.6-2.5C333,76.8,333.1,76.1,333,75.6z"
}), React.createElement("path", {
  className: "st5",
  d: "M333,75.6c-0.2-0.6-0.7-1-1.3-1.1l-3.6-0.5l-1.6-3.2c-0.3-0.5-0.9-0.8-1.4-0.8s-1.2,0.3-1.4,0.8l-1.6,3.2             l-3.6,0.5c-0.6,0.1-1.1,0.5-1.3,1.1c-0.2,0.6,0,1.2,0.5,1.6l2.6,2.5l-0.6,3.5c-0.1,0.6,0.1,1.2,0.6,1.6c0.5,0.4,1.2,0.4,1.7,0.1             l3.3-1.7l3.3,1.7c0.5,0.3,1.2,0.2,1.7-0.1c0.5-0.4,0.7-1,0.6-1.6l-0.6-3.5l2.6-2.5C333,76.8,333.1,76.1,333,75.6z"
}), React.createElement("path", {
  className: "st38",
  d: "M339.6,106.9v9.7h-29.2v-9.7c0-0.9,0.7-1.6,1.6-1.6h26C338.9,105.3,339.6,106,339.6,106.9z"
}), React.createElement("path", {
  className: "st36",
  d: "M342.8,116.8c0,0.9-0.7,1.6-1.6,1.6h-32.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6h32.4             C342.1,115.2,342.8,115.9,342.8,116.8z"
}), React.createElement("path", {
  className: "st36",
  d: "M342.8,156.3c0,0.9-0.7,1.6-1.6,1.6h-32.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6h32.4             C342.1,154.7,342.8,155.4,342.8,156.3z"
}), React.createElement("path", {
  className: "st22",
  d: "M351.2,159.5c0,0.9-1,1.6-2.4,1.6h-47.7c-1.3,0-2.4-0.7-2.4-1.6c0-0.9,1-1.6,2.4-1.6h47.7             C350.2,157.9,351.2,158.6,351.2,159.5z"
}), React.createElement("path", {
  className: "st5",
  d: "M347.6,63.4H343h0h-18v41.9v3.2v6.7v1.5v1.7v36.3h0l0,3.2h16.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6             h-1.6v-36.3h1.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6h-1.6v-8.3c0-0.9-0.7-1.6-1.6-1.6h-1.6v-1.6c0-2.7-2.2-4.8-4.8-4.8             c-0.9,0-1.6-0.7-1.6-1.6v-2.4c3.7-1.2,6.8-3.7,8.8-6.9l1.7-0.6c3.2-1.1,6-3,8.2-5.7c2.5-3.1,3.9-7,3.9-11v-2.5             C352.5,65.6,350.3,63.4,347.6,63.4z M349.3,70.7c0,3.2-1.1,6.4-3.1,9c-1.5,1.9-3.4,3.3-5.6,4.2c0.2-0.8,0.4-1.7,0.5-2.5l1.6-14.8             h5c0.9,0,1.6,0.7,1.6,1.6V70.7z"
})), React.createElement("g", null, React.createElement("circle", {
  className: "st4",
  cx: 173.1,
  cy: 83.1,
  r: 5.8
}), React.createElement("circle", {
  className: "st4",
  cx: 186.9,
  cy: 85.1,
  r: 3.1
}), React.createElement("ellipse", {
  className: "st4",
  cx: 126.4,
  cy: 72.7,
  rx: 38.5,
  ry: 30.3
})), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st38",
  d: "M141.1,67.9c-1.3,0-2.5,0.2-3.6,0.7c-0.9-2-1.6-4-2-6c-0.6-3.1-3.4-5.4-6.5-5.4c-0.8,0-1.5,0.7-1.5,1.5                 s0.7,1.5,1.5,1.5c0.3,0,0.7,0,1,0.1c1,0.3,1.8,0.9,2.3,1.8c0,0-0.1,0.1-0.1,0.2l-0.5,0.8l-2.3,3.8h-12.2l-0.7-1.7h0.3                 c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h1.6l1.3,3.2c-0.9-0.3-1.9-0.4-2.9-0.4                 c-5.6,0-10.1,4.5-10.1,10.1s4.5,10.1,10.1,10.1c5.1,0,9.3-3.8,10-8.7h2.7c0.5,0,1-0.3,1.3-0.7l7.6-12.9c0.4,1.4,1,2.8,1.6,4.1                 c-2.4,1.9-3.9,4.8-3.9,8c0,5.6,4.5,10.1,10.1,10.1s10.1-4.5,10.1-10.1C151.2,72.5,146.7,67.9,141.1,67.9z M111.7,79.5h7.1                 c-0.7,3.3-3.6,5.8-7.1,5.8c-4,0-7.2-3.2-7.2-7.2c0-4,3.2-7.2,7.2-7.2c3.5,0,6.4,2.5,7.1,5.8h-7.1c-0.8,0-1.5,0.7-1.5,1.5                 C110.2,78.8,110.9,79.5,111.7,79.5z M123.6,76.6h-1.8c-0.3-2.3-1.5-4.4-3.1-6c0-0.1,0-0.1-0.1-0.2l-0.3-0.7h9.3L123.6,76.6z                  M141.1,85.3c-4,0-7.2-3.2-7.2-7.2c0-2.1,0.9-4,2.4-5.3c1.8,3.4,3.5,6,3.7,6.2c0.3,0.4,0.7,0.6,1.2,0.6c0.3,0,0.6-0.1,0.8-0.3                 c0.7-0.5,0.8-1.4,0.4-2c0,0-1.8-2.6-3.6-6c0.7-0.3,1.5-0.4,2.4-0.4c4,0,7.2,3.2,7.2,7.2C148.3,82,145.1,85.3,141.1,85.3z"
}))), React.createElement("path", {
  className: "st5",
  d: "M246,157.2l-8.8-24.3l-12.3-7.7l-3.5-0.6l1-8.1l1.7,1.9c1.1,1.3,3,1.4,4.3,0.2l8.8-8.1c0.6,0,1.3-0.1,1.9-0.3         c2.2-1,3.2-3.5,2.3-5.7s-3.5-3.2-5.7-2.3c-1.5,0.7-2.5,2.1-2.6,3.7l-6.7,5.4l-2.9-3.3l0.5-3.9l-0.1,0c0.5-4.3-0.2-7.4-1.8-9.4         c3.3-0.3,6.4-1,8.7-2.1c12.2-5.3,8.5-25.9,3.1-33.3c1.9,0,3.7,0.1,5.1,0.3c1.4,0.2,2.6-0.8,2.8-2.1c0.2-1.3-0.8-2.6-2.1-2.8         c-2.2-0.3-5-0.4-8-0.3c-2.5-4.3-7.2-7.2-12.6-7.9c6.3,2.7,11.4,7.7,10.1,12.9c0,0,3.8,7.9,2.8,17.6c-1,9.7-12.2,14.9-12.2,14.9         l-2,14.3l-2.7,1.8l2.1,2.4l-1.8,13c0,0,10.6,6.6,13.5,18l6.3,17.9L246,157.2z"
}), React.createElement("path", {
  className: "st38",
  d: "M317.2,37.9l-1-4.9c0-0.1-0.1-0.3-0.2-0.4c0,0,0,0,0,0c-0.1-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0c0,0,0,0,0,0         c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l-4.8,1c-0.5,0.1-0.9,0.6-0.8,1.2         c0.1,0.5,0.6,0.9,1.2,0.8l2.6-0.6c-20.7,33.6-37.8,37.8-46.2,37.3c-3-0.2-5.4-1-7.4-2.1c0.7-4,0.3-7.1-1.1-8.8         c-1-1.3-2.6-1.7-4.3-1c-0.2,0.1-0.3,0.2-0.4,0.3c-1.2,1.5-1.4,3.7-0.5,5.9c0.7,1.6,2.1,3.2,4,4.6c-0.9,4-3,8.9-6.6,14.1         c-0.3,0.5-0.2,1.1,0.2,1.4c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.4c3.5-5,5.7-9.9,6.8-14.1c2.1,1.1,4.7,1.9,7.7,2.1         c8.8,0.6,26.7-3.7,47.9-38.1l0.5,2.5c0.1,0.5,0.5,0.8,1,0.8c0.1,0,0.1,0,0.2,0C316.9,38.9,317.3,38.4,317.2,37.9z M257.7,68.5         c-1.2-1-2.1-2.1-2.5-3.2c-0.4-0.8-0.8-2.3,0-3.6c0.9-0.3,1.4,0.1,1.7,0.5C257.7,63.3,258.1,65.5,257.7,68.5z"
}), React.createElement("path", {
  className: "st38",
  d: "M155,109h-1.8v-1.8c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.8h-1.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8v1.8c0,0.6,0.4,1,1,1         s1-0.4,1-1V111h1.8c0.6,0,1-0.4,1-1S155.6,109,155,109z"
}), React.createElement("path", {
  className: "st4",
  d: "M186.6,142.9h-1.8v-1.8c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.8h-1.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8v1.8         c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.8h1.8c0.6,0,1-0.4,1-1S187.2,142.9,186.6,142.9z"
}), React.createElement("path", {
  className: "st38",
  d: "M272.8,121.4l1.4-1.4c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-1.4,1.4l-1.4-1.4c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4         l1.4,1.4l-1.4,1.4c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3         s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L272.8,121.4z"
}), React.createElement("path", {
  className: "st4",
  d: "M99.9,126.9h-1.5l1.1-1.1c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-1.1,1.1V124c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.5         l-1.1-1.1c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l1.1,1.1h-1.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.5l-1.1,1.1c-0.4,0.4-0.4,1,0,1.4         c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.1-1.1v1.5c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.5l1.1,1.1c0.2,0.2,0.5,0.3,0.7,0.3         s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-1.1-1.1h1.5c0.6,0,1-0.4,1-1S100.5,126.9,99.9,126.9z"
}), React.createElement("path", {
  className: "st38",
  d: "M364.2,97.6l0.8-0.8c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-0.8,0.8l-0.8-0.8c-0.4-0.4-1-0.4-1.4,0         c-0.4,0.4-0.4,1,0,1.4l0.8,0.8l-0.8,0.8c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l0.8-0.8l0.8,0.8         c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L364.2,97.6z"
}), React.createElement("path", {
  className: "st4",
  d: "M297.5,95.2h-1.8v-1.8c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.8H292c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8v1.8         c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.8h1.8c0.6,0,1-0.4,1-1S298,95.2,297.5,95.2z"
}), React.createElement("path", {
  className: "st38",
  d: "M351.7,42.9h-1.8v-1.8c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.8h-1.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8v1.8         c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.8h1.8c0.6,0,1-0.4,1-1S352.2,42.9,351.7,42.9z"
}), React.createElement("path", {
  className: "st38",
  d: "M148.7,162.1l1.2-1.2c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-1.2,1.2l-1.2-1.2c-0.4-0.4-1-0.4-1.4,0         c-0.4,0.4-0.4,1,0,1.4l1.2,1.2l-1.2,1.2c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.2-1.2l1.2,1.2         c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L148.7,162.1z"
}), React.createElement("path", {
  className: "st38",
  d: "M283.7,49.7l1.2-1.2c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-1.2,1.2l-1.2-1.2c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4         l1.2,1.2l-1.2,1.2c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.2-1.2l1.2,1.2c0.2,0.2,0.5,0.3,0.7,0.3         s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L283.7,49.7z"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_10"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_11"
});

var SvgBuildSavingsHabits = function SvgBuildSavingsHabits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "1 0 400 210",
    style: {
      enableBackground: "new 0 0 400 210"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBuildSavingsHabits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/build_savings_habits.3c029625.svg";
export { ForwardRef as ReactComponent };